import { render, staticRenderFns } from "./RoleUsersManagement.vue?vue&type=template&id=50489ea6&scoped=true&"
import script from "./RoleUsersManagement.vue?vue&type=script&lang=js&"
export * from "./RoleUsersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50489ea6",
  null
  
)

export default component.exports